import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import {
  formatPackQty,
  groupOrdersByPos,
  orderLineQty,
  productTotals,
  type OpenOwnOrder,
} from '../../utils/pickListGrouping';

interface PickListPackOverviewProps {
  orders: OpenOwnOrder[];
}

export const PickListPackOverview: React.FC<PickListPackOverviewProps> = ({
  orders,
}) => {
  const [storesOpen, setStoresOpen] = useState(false);
  const totals = productTotals(orders);
  const stores = groupOrdersByPos(orders);

  return (
    <div className="space-y-4 pb-28">
      <div>
        <h3 className="text-sm font-black text-gray-900 mb-2">To pack</h3>
        <ul className="space-y-2">
          {totals.map((row) => (
            <li
              key={row.key}
              className={
                'flex justify-between gap-3 bg-white rounded-xl border border-gray-100 px-3 py-2'
              }
            >
              <span className="font-bold text-gray-900">
                {row.productName}
                {row.variantName ? ` · ${row.variantName}` : ''}
                <span className="block text-xs font-medium text-gray-500">
                  {row.manufacturerName}
                </span>
              </span>
              <span className="font-black text-brand-700">
                {formatPackQty(row.quantity, row.paid, row.free)}
              </span>
            </li>
          ))}
        </ul>
      </div>
      <button
        type="button"
        onClick={() => setStoresOpen((v) => !v)}
        className="flex items-center gap-2 text-sm font-bold text-gray-700"
      >
        {storesOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        Stores ({stores.length})
      </button>
      {storesOpen ? (
        <ul className="space-y-2">
          {stores.map((store) => (
            <li
              key={store.key}
              className="bg-gray-50 rounded-xl px-3 py-2 text-sm"
            >
              <p className="font-black text-gray-900">{store.posName}</p>
              {store.orders.map((order) => (
                <p key={order.id} className="text-gray-600">
                  {orderLineQty(order)} {order.product_name}
                </p>
              ))}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};
